import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const RestoreIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9 4L4 9L9 14M4 9H10.4C13.76 9 15.44 9 16.724 9.654C17.853 10.229 18.771 11.147 19.346 12.276C20 13.56 20 15.24 20 18.6V20"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

RestoreIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(RestoreIcon);
